// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-item-control1 {
  width: 100%;
  min-width: 0;

  border: 0;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0);
  background: #eef3f7;
  color: var(--text);

  font: inherit;
  line-height: 1;
  padding: 10px 6px;

  outline: none;
  font-size: 17px;


  padding: 15px;
  padding-left: 10px;
  padding-right: 10px;
}

.stock-item-control1:focus-visible {
  border-color: rgba(11, 78, 162, 0.45);
  box-shadow: 0 0 0 3px rgba(11, 78, 162, 0.12);
}`, "",{"version":3,"sources":["webpack://./src/web/component/Stock/styles.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;;EAEZ,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;;EAElB,aAAa;EACb,cAAc;EACd,iBAAiB;;EAEjB,aAAa;EACb,eAAe;;;EAGf,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C","sourcesContent":[".stock-item-control1 {\r\n  width: 100%;\r\n  min-width: 0;\r\n\r\n  border: 0;\r\n  border-radius: 8px;\r\n  border: 1px solid rgba(0, 0, 0, 0);\r\n  background: #eef3f7;\r\n  color: var(--text);\r\n\r\n  font: inherit;\r\n  line-height: 1;\r\n  padding: 10px 6px;\r\n\r\n  outline: none;\r\n  font-size: 17px;\r\n\r\n\r\n  padding: 15px;\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n}\r\n\r\n.stock-item-control1:focus-visible {\r\n  border-color: rgba(11, 78, 162, 0.45);\r\n  box-shadow: 0 0 0 3px rgba(11, 78, 162, 0.12);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
